/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageInfoDto } from '../../models/page-info-dto';
import { VendorWorkspaceDto } from '../../models/vendor-workspace-dto';

export interface VendorWorkspaceControllerSearchOffset$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 활성 여부
 */
  status: 'ACTIVED' | 'PENDING';

/**
 * 권한
 */
  role: string;
}

export function vendorWorkspaceControllerSearchOffset(http: HttpClient, rootUrl: string, params: VendorWorkspaceControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<VendorWorkspaceDto>;
'pageInfo'?: PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceControllerSearchOffset.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('status', params.status, {});
    rb.query('role', params.role, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items'?: Array<VendorWorkspaceDto>;
      'pageInfo'?: PageInfoDto;
      }>;
    })
  );
}

vendorWorkspaceControllerSearchOffset.PATH = '/api/vendorWorkspace/search/offset';
